import { TemplateScope } from '../../../models/TemplateLibrary'
import React from 'react'
import { TemplateScopeMapping } from './TemplateScopeMapping'

export interface TemplateScopeBadgeProps {
  scope: TemplateScope
}

export const TemplateScopeBadge: React.FC<TemplateScopeBadgeProps> = ({ scope }) => {
  return (
    <span className={`template-badge ${TemplateScopeMapping[scope].color} zocks-text-gray-900`}>
      <i className={`bi ${TemplateScopeMapping[scope].icon} me-1`} />
      {TemplateScopeMapping[scope].title}
    </span>
  )
}
